import * as React from "react";
import { BaseInput, type BaseInputProps } from "./BaseInput";

/**
 * Input component - Backward compatibility wrapper for BaseInput
 */
const Input = React.forwardRef<HTMLInputElement, BaseInputProps>(
  (props, ref) => {
    return <BaseInput ref={ref} {...props} />;
  },
);

Input.displayName = "Input";

export type { BaseInputProps as InputProps } from "./BaseInput";
export { Input };
